import { takeEvery, put } from "redux-saga/effects"
import { getCalendar, getPlanCalendar } from "src/engine/repositories/calendars"
import { LOAD_CALENDAR } from "../actions/types"
import {
  loadCalendarStarted,
  loadCalendarCompleted,
  loadCalendarFailed,
} from "../actions/creators"

function* loadCalendar(action) {
  yield put(loadCalendarStarted())

  const { query, planId, keepCount } = action.payload

  try {
    const { data, headers } = planId
      ? yield getPlanCalendar({ ...query, planId })
      : yield getCalendar(query)

    yield put(
      loadCalendarCompleted(data, Number(headers[`total-count`]), keepCount),
    )
  } catch (error) {
    yield put(loadCalendarFailed())
  }
}

export default function* loadCalendarWatcher() {
  yield takeEvery(LOAD_CALENDAR, loadCalendar)
}
